import styled from 'styled-components';

export const Conitaner = styled.div(
  props => `
  .fieldWrap {
    position: relative;
    margin-bottom: 32px;
  }

  .DayPicker-wrapper {
    margin-top: 20px;
  }

  .DayPicker-Day {
    width: 30px;
    height: 30px;
  }

  .DayPicker-Months {
    display: flex;
    align-items: flex-start;
    /* flex-wrap: nowrap; */
    justify-content: space-around;
    /* justify-content: space-between; */
  }

  .DayPicker .Range {
    margin: 20px 0px 0px 0px;
  }

  .datePickerWrap {
    position: absolute;
    /* top:27px; */
    //bottom: 0px;
    //left: 0px;
    width: ${props.singleDate} ? '648px' : '400px';
    /* height: 400px; */
    background: #fff;
    border: 1px solid #d8d8d8;
    box-sizing: border-box;
    box-shadow: 0px 7px 7px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 16px;
    z-index: 1;
  }

  .datePickerWrap .dateTab {
    display: flex;
    border-bottom: solid 2px #f2f2f2;
  }

  .datePickerWrap .dateTab li {
    /* max-width:80px; */
    display: flex;
    flex-direction: column;
    padding-bottom: 14px;
    margin-right: 48px;
    cursor: pointer;
    margin-bottom: -2px;
  }

  .dateTab li:first-of-type {
    margin-left: 10px;
  }

  .datePickerWrap .dateTab li.active {
    border-bottom: solid 2px #008cff;
  }

  .datePickerWrap .dateTab li .dateType {
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    text-transform: uppercase;
    color: #9b9b9b;
    margin-bottom: 3px;
  }

  .datePickerWrap .dateTab li .dateFormat {
    display: flex;
    font-size: 12px;
    color: #4a4a4a;
    align-items: flex-end;
  }

  .datePickerWrap .dateTab li .dateFormat .dateMonthText {
    font-weight: 800;
    font-size: 13px;
    color: #000000;
    margin-right: 4px;
  }

  .datePickerWrap .DayPicker-NavBar {
    position: absolute;
    width: 100%;
    display: flex;
  }

  .datePickerWrap .DayPicker-NavButton {
    right: unset;
    left: unset;
  }

  .DayPicker-NavButton--next,
  .DayPicker-NavButton--prev {
    background-image: none;
    background: url(../../assets/arrow.png) no-repeat;
    background-size: 22px 23px;
  }

  .DayPicker-NavButton--next {
    right: 0px !important;
    transform: rotate(180deg);
  }

  .datePickerWrap .DayPicker-Month {
    width: 47%;
    margin: 16px 0 0px;
    /* margin-right: 10px; */
  }

  .datePickerWrap .DayPicker-Caption {
    text-align: center;
    font-size: 20px;
    color: #28042f;
  }

  .datePickerWrap .DayPicker-Day {
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #28042f;
    border-radius: 4px;

    height: 40px;
    width: 40px;
  }

  /* .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside),.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
  position: relative;
  background-color: linear-gradient(135deg, #008cff 0%, #5aaaf8 100%) !important;;
  color: #fff;
} */

  .datePickerWrap
    .Range
    .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    /* width: 40px;
  height: 40px; */
    background-color: #edf1f8;
    color: #28042f;
  }

  .datePickerWrap
    .DayPicker:not(.DayPicker--interactionDisabled)
    .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
    background-color: #edf1f8;
  }

  .datePickerWrap .DayPicker-Day--start:not(.DayPicker-Day--outside),
  .datePickerWrap .DayPicker-Day--end:not(.DayPicker-Day--outside) {
    background: linear-gradient(135deg, #008cff 0%, #5aaaf8 100%) !important;
    color: #fff !important;
  }

  .datePickerWrap .DayPicker-Day--disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  .datePickerWrap .dateBtnWrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: auto;
  }

  .dateBtnWrap .cancelDate {
    font-size: 18px;
    line-height: 21px;
    text-align: center;
    color: #141823;
    margin-right: 24px;
    cursor: pointer;
  }

  .dateBtnWrap .dateDoneBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 24px;
    width: 90px;
    height: 37px;
    background: linear-gradient(135deg, #008cff 0%, #5aaaf8 100%);
    border-radius: 8px;
    color: #fff;
    font-size: 18px;
    border: none;
    outline: none;
    cursor: pointer;
  }

  .dateField {
    width: 176px;
    height: 48px;
    border: 1px solid #e7e7e7;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    cursor: pointer;
    margin-right: 8px;
  }

  .dateSelectWrap .dateField:last-of-type {
    margin-right: unset;
  }

  .dateField:focus-within {
    border: 1px solid #ec6648;
  }

  .dateField.addDate {
    font-size: 12px;
    line-height: 16px;
    color: #0170f2;
    font-family: 800;
    margin-left: 10px;
    font-weight: 700;
  }

  .dateField .dateCalIcon {
    margin-right: 10px;
  }

  .dateField label {
    font-size: 11px;
    color: #7a6a7d;
    font-weight: 700;
    text-transform: uppercase;
  }

  .dateDayWrap {
    display: flex;
    align-items: baseline;
  }

  .dateField .dateText {
    font-weight: 800;
    font-size: 14px;
    line-height: 16px;
    color: #28042f;
  }

  .dateField .dayText {
    font-size: 12px;
    line-height: 16px;
    color: #564959;
    font-weight: 400;
    margin-left: 4px;
  }

  .calenderWrap {
    position: absolute;
    top: 0px;
    left: 0px;
  }

  .addReturnDate {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    color: #0170f2;
  }

  .dateSelectHeader {
    border-bottom: solid 1px #e7e7e7;
    margin: 0px -16px;
    padding: 0 16px 16px 16px;
  }

  .trvlDateField {
    display: flex;
    border: 4px;
  }

  .startDate,
  .endDate {
    width: 216px;
    margin-right: 16px;
  }

  .trvlDateField .labelText {
    font-size: 14px;
    line-height: 16px;
    font-weight: 900;
    color: #4a4a4a;
    margin-bottom: 8px;
  }

  .trvlDateField .outputText {
    font-size: 14px;
    font-weight: 700;
  }

  .dayPickerInputBox input[type='text'] {
    background: none;
    outline: 0;
    border: 0;
    padding: 14px 12px;
    font-weight: 400;
    font-size: 14px;
    cursor: pointer;
    background: #ffffff;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    color: #000000;
    width: 100%;
  }

  .inputContainer {
    position: relative;
  }

  .arrow {
    border: solid #757575;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    position: absolute;
    right: 15px;
    top: 3px;
  }

  .down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }

  @media only screen and (max-width: 768px) {
    &.dateSelectWrap {
      flex-direction: column;
    }

    .dateSelectWrap .formField {
      flex-direction: row;
      justify-content: space-between;
    }

    .dateField {
      width: 49%;
      margin-right: unset;
      padding: 0px 0px 0px 16px;
      margin-bottom: 16px;
    }

    .datePickerWrap {
      width: 100%;
      height: 100%;
      position: fixed;
      z-index: 1;
      top: 0px;
      left: 0px;
      overflow: auto;
      border: none;
      border-radius: unset;
      padding: 0px;
      padding-bottom: 140px;
    }

    .dateSelectHeader {
      z-index: 1;
      background: #fff;
      padding: 16px 24px;
      display: flex;
      align-items: center;
      position: sticky;
      top: 0px;
      font-weight: bold;
      font-size: 18px;
      line-height: 22px;
      color: #28042f;
      border-bottom: solid 2px #f2f2f2;
    }

    .dateSelectHeader .arrowBackIcon {
      margin-right: 16px;
    }

    .dateBtnWrap {
      width: 100%;
      background: #fff;
      position: fixed;
      bottom: 0px;
      left: 0px;
      z-index: 2;
      display: flex;
      flex-direction: column;
      padding: 16px 24px;
    }

    .dateBtnWrap .dateDoneBtn {
      width: 100%;
      height: 44px;
      text-transform: uppercase;
      font-size: 16px;
      font-weight: 800;
    }

    .dateBtnWrap .dateField {
      padding: 0px 0 0 10px;
    }

    .dateBtnWrap .dateField .dateInner {
      min-width: 113px;
    }

    .datePickerWrap .DayPicker-Month {
      width: 100%;
      /* margin: 24px; */
      position: relative;
    }

    .datePickerWrap .DayPicker-Month::after {
      content: '';
      position: absolute;
      bottom: -30px;
      left: -24px;
      width: calc(100% + 48px);
      border-bottom: solid 8px #f2f2f2;
    }

    .datePickerWrap .DayPicker-Day {
      height: 44px;
      border: solid 1px #d8d8d8;
    }

    .datePickerWrap .DayPicker-Day.DayPicker-Day--outside {
      border: unset;
    }

    .datePickerWrap .DayPicker-Month:first-of-type {
      border-right: unset;
    }

    .datePickerWrap .DayPicker-Day {
      border-radius: unset;
    }

    .datePickerWrap .DayPicker-Caption {
      text-align: unset;
      font-size: 16px;
      padding: unset;
    }

    .datePickerWrap .formField {
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .rdp {
    --rdp-cell-size: 40px;
    --rdp-caption-font-size: 18px;
    --rdp-accent-color: #0000ff;
    --rdp-background-color: #e7edff;
    --rdp-accent-color-dark: #3003e1;
    --rdp-background-color-dark: #180270;
    --rdp-outline: 2px solid var(--rdp-accent-color); /* Outline border for focused elements */
    --rdp-outline-selected: 3px solid var(--rdp-accent-color); /* Outline border for focused _and_ selected elements */

    margin: 1em;
  }

  /* Hide elements for devices that are not screen readers */
  .rdp-vhidden {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    background: transparent;
    border: 0;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    position: absolute !important;
    top: 0;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    overflow: hidden !important;
    clip: rect(1px, 1px, 1px, 1px) !important;
    border: 0 !important;
  }

  /* Buttons */
  .rdp-button_reset {
    appearance: none;
    position: relative;
    margin: 0;
    padding: 0;
    cursor: default;
    color: inherit;
    background: none;
    font: inherit;

    -moz-appearance: none;
    -webkit-appearance: none;
  }

  .rdp-button_reset:focus-visible {
    /* Make sure to reset outline only when :focus-visible is supported */
    outline: none;
  }

  .rdp-button {
    border: 2px solid transparent;
  }

  .rdp-button[disabled]:not(.rdp-day_selected) {
    opacity: 0.25;
  }

  .rdp-button:not([disabled]) {
    cursor: pointer;
  }

  .rdp-button:focus-visible:not([disabled]) {
    color: inherit;
    background-color: var(--rdp-background-color);
    border: var(--rdp-outline);
  }

  .rdp-button:hover:not([disabled]):not(.rdp-day_selected) {
    background-color: var(--rdp-background-color);
  }

  .rdp-months {
    display: flex;
  }

  .rdp-month {
    margin: 0 1em;
  }

  .rdp-month:first-child {
    margin-left: 0;
  }

  .rdp-month:last-child {
    margin-right: 0;
  }

  .rdp-table {
    margin: 0;
    max-width: calc(var(--rdp-cell-size) * 7);
    border-collapse: collapse;
  }

  .rdp-with_weeknumber .rdp-table {
    max-width: calc(var(--rdp-cell-size) * 8);
    border-collapse: collapse;
  }

  .rdp-caption {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    text-align: left;
  }

  .rdp-multiple_months .rdp-caption {
    position: relative;
    display: block;
    text-align: center;
  }

  .rdp-caption_dropdowns {
    position: relative;
    display: inline-flex;
  }

  .rdp-caption_label {
    position: relative;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    margin: 0;
    padding: 0 0.25em;
    white-space: nowrap;
    color: currentColor;
    border: 0;
    border: 2px solid transparent;
    font-family: inherit;
    font-size: var(--rdp-caption-font-size);
    font-weight: bold;
  }

  .rdp-nav {
    white-space: nowrap;
  }

  .rdp-multiple_months .rdp-caption_start .rdp-nav {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  .rdp-multiple_months .rdp-caption_end .rdp-nav {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }

  .rdp-nav_button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--rdp-cell-size);
    height: var(--rdp-cell-size);
    padding: 0.25em;
    border-radius: 100%;
  }

  /* ---------- */
  /* Dropdowns  */
  /* ---------- */

  .rdp-dropdown_year,
  .rdp-dropdown_month {
    position: relative;
    display: inline-flex;
    align-items: center;
  }

  .rdp-dropdown {
    appearance: none;
    position: absolute;
    z-index: 2;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    margin: 0;
    padding: 0;
    cursor: inherit;
    opacity: 0;
    border: none;
    background-color: transparent;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  .rdp-dropdown[disabled] {
    opacity: unset;
    color: unset;
  }

  .rdp-dropdown:focus-visible:not([disabled]) + .rdp-caption_label {
    background-color: var(--rdp-background-color);
    border: var(--rdp-outline);
    border-radius: 6px;
  }

  .rdp-dropdown_icon {
    margin: 0 0 0 5px;
  }

  .rdp-head {
    border: 0;
  }

  .rdp-head_row,
  .rdp-row {
    height: 100%;
  }

  .rdp-head_cell {
    vertical-align: middle;
    font-size: 0.75em;
    font-weight: 700;
    text-align: center;
    height: 100%;
    height: var(--rdp-cell-size);
    padding: 0;
    text-transform: uppercase;
  }

  .rdp-tbody {
    border: 0;
  }

  .rdp-tfoot {
    margin: 0.5em;
  }

  .rdp-cell {
    width: var(--rdp-cell-size);
    height: 100%;
    height: var(--rdp-cell-size);
    padding: 0;
    text-align: center;
  }

  .rdp-weeknumber {
    font-size: 0.75em;
  }

  .rdp-weeknumber,
  .rdp-day {
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: var(--rdp-cell-size);
    max-width: var(--rdp-cell-size);
    height: var(--rdp-cell-size);
    margin: 0;
    border: 2px solid transparent;
    border-radius: 100%;
  }

  .rdp-day_today:not(.rdp-day_outside) {
    font-weight: bold;
  }

  .rdp-day_selected,
  .rdp-day_selected:focus-visible,
  .rdp-day_selected:hover {
    opacity: 1;
    background: linear-gradient(
135deg
, #008cff 0%, #5aaaf8 100%) !important;
    color: #fff !important;
  }

  .rdp-day_outside {
    opacity: 0.5;
  }

  .rdp-day_selected:focus-visible {
    /* Since the background is the same use again the outline */
    outline: var(--rdp-outline);
    outline-offset: 2px;
    z-index: 1;
  }

  .rdp:not([dir='rtl']) .rdp-day_range_start:not(.rdp-day_range_end) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .rdp:not([dir='rtl']) .rdp-day_range_end:not(.rdp-day_range_start) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .rdp[dir='rtl'] .rdp-day_range_start:not(.rdp-day_range_end) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .rdp[dir='rtl'] .rdp-day_range_end:not(.rdp-day_range_start) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .rdp-day_range_end.rdp-day_range_start {
    border-radius: 100%;
  }

  .rdp-day_range_middle {
    border-radius: 0;
  }
`,
);
export const Error = styled.p`
  margin-top: 0.8rem;
  color: red;
`;
